
import clsx from 'clsx'
import { KTIcon } from '../../../helpers'
import { useLayout } from '../../core'
import { DefaultTitle } from '../header/page-title/DefaultTitle'
interface Props {
  rightSection?: React.ReactNode,
  extraClass?: string
  customPadding?: string
}
const ManageProjectToolbar: React.FC<Props> = ({ rightSection, extraClass, customPadding='py-8' }) => {
  const { classes } = useLayout()
  return (
    <>
      <div className={`toolbar ${customPadding}`} id='kt_toolbar'>
        {/* begin::Container */}
        <div
          id='kt_toolbar_container'
          className={clsx(classes.toolbarContainer.join(' '), extraClass, ' d-flex flex-stack')}
        >
          <DefaultTitle /> <div className='text-gray-800 fs-3'>{rightSection}</div>
        </div>
        {/* end::Container */}
      </div>
    </>
  )
}

export { ManageProjectToolbar }
